"use strict";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  &.styled-select {\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    visibility: ", ";\n    box-sizing: ", ";\n    transition: ", ";\n    transform: ", ";\n    text-indent: ", ";\n\n    ", "\n\n    .styled-select__placeholder {\n      color: ", ";\n      font-size: ", "px;\n    }\n\n    .styled-select__indicator-separator {\n      display: none;\n    }\n\n    .styled-select__menu {\n      box-shadow: none;\n      ", "\n\n      ", "\n    }\n\n    .styled-select__option {\n      padding-top: 2px;\n      padding-bottom: 2px;\n\n      &--is-focused,\n      &--is-selected {\n        background: ", ";\n        color: ", ";\n      }\n\n    }\n\n    .styled-select__control {\n      ", "\n      ", "\n      ", "\n      text-indent: ", ";\n\n      &--is-focused {\n        ", "\n\n        ", "\n\n        background: ", ";\n        box-shadow: none;\n\n        .styled-select__value-container {\n          background: ", ";\n        }\n\n        .styled-select__indicators {\n          background: ", ";\n        }\n\n        .styled-select__placeholder {\n          color: ", ";\n        }\n      }\n    }\n\n    /* Select dropdown */\n    .styled-select__single-value {\n      color: ", ";\n      font-family: ", ";\n    }\n\n    &:hover {\n      cursor: ", ";\n    }\n\n    ", "\n\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _styledSystem = require("styled-system");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Select = (0, _styledComponents.default)(_reactSelect.default)(_templateObject(), _styledSystem.space, _styledSystem.width, _styledSystem.height, _styledSystem.borders, _styledSystem.borderColor, _styledSystem.color, _styledSystem.maxWidth, _styledSystem.minWidth, _styledSystem.minHeight, _styledSystem.maxHeight, _styledSystem.borderRadius, _styledSystem.backgroundImage, _styledSystem.backgroundSize, _styledSystem.backgroundPosition, _styledSystem.backgroundRepeat, _styledSystem.display, _styledSystem.top, _styledSystem.right, _styledSystem.bottom, _styledSystem.left, _styledSystem.position, _styledSystem.alignSelf, _styledSystem.zIndex, _styledSystem.fontSize, _styledSystem.fontFamily, _styledSystem.boxShadow, _styledSystem.overflow, _styledSystem.opacity, function (props) {
  return props.visibility || 'visible';
}, function (props) {
  return props.boxSizing || 'content-box';
}, function (props) {
  return props.transition || 'all 0s 0s ease';
}, function (props) {
  return props.transform || 'none';
}, function (props) {
  return props.textIndent || '0';
}, function (props) {
  return props.variant === 'clear' && "\n      .styled-select__value-container {\n        padding-left: 0;\n      }\n\n      .styled-select__control {\n        height: 30px !important;\n      }\n    ";
}, function (props) {
  return props.placeholderColor || props.theme.colors.wagGray;
}, function (props) {
  return props.theme.fontSizes[4];
}, function (props) {
  return !props.variant && "\n        border: 2px solid " + props.theme.colors.wagGray + ";\n      ";
}, function (props) {
  return props.variant === 'clear' && "\n        border: 1px solid #EDEDED;\n        border-radius: 8px;\n        background-color: #FFFFFF;\n        box-shadow: 0 2px 12px 0 rgba(0,0,0,0.12);\n      ";
}, function (props) {
  return props.theme.colors.wagGreen;
}, function (props) {
  return props.theme.colors.white;
}, _styledSystem.color, _styledSystem.borders, _styledSystem.height, function (props) {
  return props.textIndent || '0';
}, function (props) {
  return !props.variant && "\n          border: 2px solid " + props.theme.colors.wagGray + ";\n        ";
}, function (props) {
  return props.variant === 'clear' && "\n          padding: 0;\n        ";
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors.medGray;
}, function (props) {
  return props.theme.colors.medGray;
}, function (props) {
  return props.theme.fonts.subHeading;
}, function (props) {
  return props.hover ? 'pointer' : 'auto';
}, function (props) {
  return props.error && "\n      border: 1px solid " + (props.theme.colors.wagRed || 'red') + ";\n      border-radius: 5px;\n    ";
}, function (props) {
  return props.error && props.variant === 'clear' && "\n      border: none;\n      border-radius: 5px;\n    ";
});
var _default = Select;
exports.default = _default;